import { useEffect, useState } from "react";
import axios from "axios";
import { SelectOption } from "../types";
import { adminService } from "../../../../../configs/constants";

export const useGeneralServiceRequestByOrgId = (orgId, isEnabled) => {
  const [requestData, setRequestData]: any = useState<SelectOption | null>(
    null
  );
  const [residentialOption, setResidentialOption]: any =
    useState<SelectOption | null>(null);
  const [commercialOption, setCommercialOption]: any =
    useState<SelectOption | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${adminService}/general-services?orgId=${orgId}`
      );

      const option = response.data?.result?.commercialCategories.map((cat) => ({
        label: cat.categoryName,
        value: cat.categoryId,
      }));

      setCommercialOption(option || []);

      const options = response.data?.result?.residentialCategories.map(
        (cat) => ({
          label: cat.categoryName,
          value: cat.categoryId,
        })
      );

      setResidentialOption(options || []);

      setRequestData(response.data?.result);
      setError(null);
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [orgId, isEnabled]);

  return {
    requestData,
    residentialOption,
    commercialOption,
    loading,
    error,
    refetch: fetchData,
  };
};
